<template>
  <v-card class="mx-auto" height="100%" width="100%">
    <span v-if="isLoadding" style="height: 100px">
      <v-container
        fill-height
        fluid
        :style="
          display === 'Desktop'
            ? 'height: ' + (heightDisplay - 325) + 'px;'
            : 'height: ' + (heightDisplay - 150) + 'px;'
        "
      >
        <v-row align="center" justify="center">
          <v-col
            lg="12"
            sm="12"
            md="12"
            cols="12"
            xl="12"
            xs="12"
            class="text-center"
            ><h1 style="font-size: 48px">
              <span style="color: #3F44A3">Kan</span>
              <span style="color: #4A98B2">Pramool</span>
            </h1>
          </v-col>
          <v-col
            class="text-center"
            sm="10"
            md="6"
            cols="8"
            xl="3"
            xs="10"
            lg="3"
            ><v-progress-linear
              color="#F8F364"
              indeterminate
              rounded
              height="6"
            ></v-progress-linear
          ></v-col>
        </v-row>
      </v-container>
    </span>

    <v-navigation-drawer
 
      absolute
      dark
      src="../assets/images.jpg"
      width="100%"
      permanent
    >
      <Navbar />
      <div class="min-height">
        <v-content>
          <form class="height" v-on:submit.prevent="login()">
            <v-container fill-height>
              <v-row align="center" justify="center" style="height: 100%">
                <v-col cols="12" sm="8" md="4">
                  <v-card class="elevation-12">
                    <v-toolbar color="black" dark flat>
                      <v-toolbar-title>ลงชื่อเข้าสู่ระบบ</v-toolbar-title>
                      <v-spacer />
                    </v-toolbar>
                    <v-card-text>
                      <v-text-field
                        label="ชื่อผู้ใช้"
                        name="login"
                        type="text"
                        v-model="form.username"
                      />
                      <v-text-field
                        id="password"
                        label="รหัสผ่าน"
                        name="password"
                        type="password"
                        v-model="form.password"
                      />
                    </v-card-text>
                    <span class="m-1">
                      <v-alert
                        :value="alert"
                        color="pink"
                        dark
                        border="top"
                        icon="mdi-alert"
                        transition="scale-transition"
                        >คุณไม่มีสิทธิ์เข้าสู่ระบบ
                        โปรดติดต่อผู้รับผิดชอบ</v-alert
                      >
                    </span>
                    <v-card-actions>
                      <v-spacer />
                      <v-btn small type="submit" color="red">เข้าสู่ระบบ</v-btn>
                    </v-card-actions>
                  </v-card>
                </v-col>
              </v-row>
            </v-container>
          </form>
        </v-content>
      </div>
    </v-navigation-drawer>
  </v-card>
</template>

<script>
import md5 from "crypto-js/md5";
import axios from "axios";
import Navbar from "../components/navbarBox";
export default {
  components: { Navbar },
  data() {
    return {
      moment: false,
      display: false,
      heightDisplay: null,
      isLoadding: true,
    
      alert: false,
      interval: {},
      value: 0,
      form: {
        username: "",
        password: "",
      },
      ipaddress: null,
    };
  },

  beforeDestroy() {
    clearInterval(this.interval);
  },
  mounted() {
    this.isLoadding = true;
    if (this.$route.fullPath === "/login") {
      if (localStorage.getItem("username") !== null) {

        this.$router.push("/homepage");
      }
    } else {
      if (localStorage.getItem("username") === null) {

        this.$router.push("/login");
      } else {
        this.fullname = localStorage.getItem("fullname");
      }
    }
    // this.loaddingPage();
    this.checkHightDisplay();
    // this.$axios
    //   .post(this.api + "/checkversion", { version: this.version.split(" ")[3] })
    //   .then((res) => {
    //     if (!res.data.status) {
    //       alert("เวอรันที่ใช้งานไม่ตรงกับเวอร์ชันปัจจุบัน");
    //       location.reload();
    //     }
    //   });
    axios.get("https://api.db-ip.com/v2/free/self").then((res) => {
      this.isLoadding = false
      this.ipaddress = res.data.ipAddress;
    });
  },
  methods: {
    loaddingPage() {
      
      setTimeout(() => (this.isLoadding = false), 3000);
      setTimeout(() => (this.dialog = !false), 3000);
    },
    checkHightDisplay() {
      this.heightDisplay = screen.height;
  
    },
    login() {
      let md5Hash = md5(this.form.password);
      this.form.password = md5Hash.toString();

      axios.post(this.api + "/login", this.form).then((res) => {
        if (res.data.status) {
          localStorage.setItem("username", res.data.response.username);
          localStorage.setItem("fullname", res.data.response.fullname);
          localStorage.setItem("role", res.data.response.role);
          localStorage.setItem("ipaddress", this.ipaddress);
          this.$router.push("/homepage");
        } else {
          this.alert = true;
        }
      })
      .catch(() => {
        console.log("asdasd")
      });
    },
  },
};
</script>
<style>
.min-height {
  margin: auto;
  height: 100%;
}
.height {
  height: 80vh;
}
</style>
